export default __webpack_public_path__ + "static/lsa-mobile-screens-b5e6e0cef9cfe774bab5ac942d504002.jpg";